export default __webpack_public_path__ + "0a12abbf2e58230089e636d8ea1a7e25.png";